import { addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { CreateServicePrimaryTag, ServicePrimaryTag } from "../types";
import { TagTypeDB } from "./TagType";

export const createTagType = async (
  tag: CreateServicePrimaryTag,
): Promise<ServicePrimaryTag> => {
  const collectionRef = collection(db, "servicePrimaryTags");

  const tagTypeRef = await addDoc(collectionRef, tag);

  const newTagTypeSnapshot = await getDoc(tagTypeRef);

  const newTagType = new TagTypeDB(newTagTypeSnapshot);

  return newTagType.toTagType();
};
